module.exports = __webpack_public_path__ + "img/lion.jpg";